unit View.Contadores.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer;

type
  TFViewContadoresEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbemail: TLabel;
    edemail: TDBEdit;
    lbcnpj: TLabel;
    edcnpj: TDBEdit;
    lbcidade_id: TLabel;
    edcidade_id: TDBEdit;
    lbendereco: TLabel;
    edendereco: TDBEdit;
    lbcep: TLabel;
    edcep: TDBEdit;
    lbtelefone: TLabel;
    edtelefone: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientContadoresGet: TXDataWebClient;
    ContadoresDataset: TXDataWebDataSet;
    ContadoresDatasetid: TIntegerField;
    ContadoresDatasetaliado_id: TIntegerField;
    ContadoresDatasetdata_base_id: TIntegerField;
    ContadoresDatasetnome: TStringField;
    ContadoresDatasetemail: TStringField;
    ContadoresDatasetcnpj: TStringField;
    ContadoresDatasetcidade_id: TIntegerField;
    ContadoresDatasetendereco: TStringField;
    ContadoresDatasetbairro: TStringField;
    ContadoresDatasetnumero: TStringField;
    ContadoresDatasetcomplemento: TStringField;
    ContadoresDatasetcep: TStringField;
    ContadoresDatasettelefone: TStringField;
    ContadoresDatasetcodigo_interno: TIntegerField;
    ContadoresDatasetexcluido: TBooleanField;
    ContadoresDatasetinclusao: TDateTimeField;
    ContadoresDatasetalteracao: TDateTimeField;
    ContadoresDatasetexclusao: TDateTimeField;
    ContadoresDatasetcidadeNome: TStringField;
    ContadoresDatasetcidadeufSigla: TStringField;
    cbxexcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientContadoresGetLoad(Response: TXDataClientResponse);
    procedure ContadoresDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure ContadoresDatasetcnpjGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasetemailGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasetenderecoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasetcepGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasettelefoneGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasetcidadeNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewContadoresEdit: TFViewContadoresEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewContadoresEdit }

class function TFViewContadoresEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewContadoresEdit.InsertEntity;
begin
  ContadoresDataset.Close;
  ContadoresDataset.SetJsonData('{}');
  ContadoresDataset.Open;
  ContadoresDataset.Insert;
end;

class function TFViewContadoresEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewContadoresEdit(AForm).FInserting := AInserting;
    TFViewContadoresEdit(AForm).FId := AId;
    TFViewContadoresEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewContadoresEdit(AForm).InsertEntity
    else
      TFViewContadoresEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewContadoresEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewContadoresEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ContadoresDataset.Connection.Model.DefaultSchema.FindEntityType(
      ContadoresDataset.EntitySetName
    )
  );
  XDataClientContadoresGet.Get(ContadoresDataset.EntitySetName, QueryString + ',cidade/uf', FId);
end;

procedure TFViewContadoresEdit.XDataClientContadoresGetLoad(Response: TXDataClientResponse);
begin
  ContadoresDataset.Close;
  ContadoresDataset.SetJsonData(Response.Result);
  ContadoresDataset.Open;
  
  ContadoresDataset.Edit;  
end;

procedure TFViewContadoresEdit.ContadoresDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewContadoresEdit.ContadoresDatasetcepGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCEP(Sender.AsString);
end;

procedure TFViewContadoresEdit.ContadoresDatasetcidadeNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, ContadoresDataset.FieldByName('cidade.uf.Sigla').AsString);
end;

procedure TFViewContadoresEdit.ContadoresDatasetcnpjGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewContadoresEdit.ContadoresDatasetemailGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := UpperCase(Sender.AsString);
end;

procedure TFViewContadoresEdit.ContadoresDatasetenderecoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarEndereco(ContadoresDataset.FieldByName('endereco').AsString,
    ContadoresDataset.FieldByName('numero').AsString, ContadoresDataset.FieldByName('bairro').AsString,
      ContadoresDataset.FieldByName('complemento').AsString, False);
end;

procedure TFViewContadoresEdit.ContadoresDatasettelefoneGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarTelefone(Sender.AsString);
end;

procedure TFViewContadoresEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewContadoresEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.contadores.form.lbid');
  lbnome := TLabel.Create('view.contadores.form.lbnome');
  lbemail := TLabel.Create('view.contadores.form.lbemail');
  lbcnpj := TLabel.Create('view.contadores.form.lbcnpj');
  lbcidade_id := TLabel.Create('view.contadores.form.lbcidade_id');
  lbendereco := TLabel.Create('view.contadores.form.lbendereco');
  lbcep := TLabel.Create('view.contadores.form.lbcep');
  lbtelefone := TLabel.Create('view.contadores.form.lbtelefone');
  lbcodigo_interno := TLabel.Create('view.contadores.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.contadores.form.lbexcluido');
  lbinclusao := TLabel.Create('view.contadores.form.lbinclusao');
  lbalteracao := TLabel.Create('view.contadores.form.lbalteracao');
  lbexclusao := TLabel.Create('view.contadores.form.lbexclusao');
  btCancel := TButton.Create('view.contadores.form.btBack');
  edid := TDBEdit.Create('view.contadores.form.edid');
  ednome := TDBEdit.Create('view.contadores.form.ednome');
  edemail := TDBEdit.Create('view.contadores.form.edemail');
  edcnpj := TDBEdit.Create('view.contadores.form.edcnpj');
  edcidade_id := TDBEdit.Create('view.contadores.form.edcidade_id');
  edendereco := TDBEdit.Create('view.contadores.form.edendereco');
  edcep := TDBEdit.Create('view.contadores.form.edcep');
  edtelefone := TDBEdit.Create('view.contadores.form.edtelefone');
  edcodigo_interno := TDBEdit.Create('view.contadores.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.contadores.form.edinclusao');
  edalteracao := TDBEdit.Create('view.contadores.form.edalteracao');
  edexclusao := TDBEdit.Create('view.contadores.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.contadores.form.cbxexcluido');
  DataSource := TDataSource.Create(Self);
  ContadoresDataset := TXDataWebDataSet.Create(Self);
  ContadoresDatasetid := TIntegerField.Create(Self);
  ContadoresDatasetaliado_id := TIntegerField.Create(Self);
  ContadoresDatasetdata_base_id := TIntegerField.Create(Self);
  ContadoresDatasetnome := TStringField.Create(Self);
  ContadoresDatasetemail := TStringField.Create(Self);
  ContadoresDatasetcnpj := TStringField.Create(Self);
  ContadoresDatasetcidade_id := TIntegerField.Create(Self);
  ContadoresDatasetendereco := TStringField.Create(Self);
  ContadoresDatasetbairro := TStringField.Create(Self);
  ContadoresDatasetnumero := TStringField.Create(Self);
  ContadoresDatasetcomplemento := TStringField.Create(Self);
  ContadoresDatasetcep := TStringField.Create(Self);
  ContadoresDatasetcodigo_interno := TIntegerField.Create(Self);
  ContadoresDatasettelefone := TStringField.Create(Self);
  ContadoresDatasetexcluido := TBooleanField.Create(Self);
  ContadoresDatasetinclusao := TDateTimeField.Create(Self);
  ContadoresDatasetalteracao := TDateTimeField.Create(Self);
  ContadoresDatasetexclusao := TDateTimeField.Create(Self);
  ContadoresDatasetcidadeNome := TStringField.Create(Self);
  ContadoresDatasetcidadeufSigla := TStringField.Create(Self);
  XDataClientContadoresGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbemail.BeforeLoadDFMValues;
  lbcnpj.BeforeLoadDFMValues;
  lbcidade_id.BeforeLoadDFMValues;
  lbendereco.BeforeLoadDFMValues;
  lbcep.BeforeLoadDFMValues;
  lbtelefone.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edemail.BeforeLoadDFMValues;
  edcnpj.BeforeLoadDFMValues;
  edcidade_id.BeforeLoadDFMValues;
  edendereco.BeforeLoadDFMValues;
  edcep.BeforeLoadDFMValues;
  edtelefone.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ContadoresDataset.BeforeLoadDFMValues;
  ContadoresDatasetid.BeforeLoadDFMValues;
  ContadoresDatasetaliado_id.BeforeLoadDFMValues;
  ContadoresDatasetdata_base_id.BeforeLoadDFMValues;
  ContadoresDatasetnome.BeforeLoadDFMValues;
  ContadoresDatasetemail.BeforeLoadDFMValues;
  ContadoresDatasetcnpj.BeforeLoadDFMValues;
  ContadoresDatasetcidade_id.BeforeLoadDFMValues;
  ContadoresDatasetendereco.BeforeLoadDFMValues;
  ContadoresDatasetbairro.BeforeLoadDFMValues;
  ContadoresDatasetnumero.BeforeLoadDFMValues;
  ContadoresDatasetcomplemento.BeforeLoadDFMValues;
  ContadoresDatasetcep.BeforeLoadDFMValues;
  ContadoresDatasetcodigo_interno.BeforeLoadDFMValues;
  ContadoresDatasettelefone.BeforeLoadDFMValues;
  ContadoresDatasetexcluido.BeforeLoadDFMValues;
  ContadoresDatasetinclusao.BeforeLoadDFMValues;
  ContadoresDatasetalteracao.BeforeLoadDFMValues;
  ContadoresDatasetexclusao.BeforeLoadDFMValues;
  ContadoresDatasetcidadeNome.BeforeLoadDFMValues;
  ContadoresDatasetcidadeufSigla.BeforeLoadDFMValues;
  XDataClientContadoresGet.BeforeLoadDFMValues;
  try
    Name := 'FViewContadoresEdit';
    Width := 492;
    Height := 302;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 12;
    lbid.Width := 52;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 8;
    lbnome.Top := 41;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbemail.SetParentComponent(Self);
    lbemail.Name := 'lbemail';
    lbemail.Left := 8;
    lbemail.Top := 68;
    lbemail.Width := 28;
    lbemail.Height := 13;
    lbemail.Caption := 'Email:';
    lbemail.HeightPercent := 100.000000000000000000;
    lbemail.WidthPercent := 100.000000000000000000;
    lbcnpj.SetParentComponent(Self);
    lbcnpj.Name := 'lbcnpj';
    lbcnpj.Left := 8;
    lbcnpj.Top := 95;
    lbcnpj.Width := 58;
    lbcnpj.Height := 13;
    lbcnpj.Caption := 'Documento:';
    lbcnpj.HeightPercent := 100.000000000000000000;
    lbcnpj.WidthPercent := 100.000000000000000000;
    lbcidade_id.SetParentComponent(Self);
    lbcidade_id.Name := 'lbcidade_id';
    lbcidade_id.Left := 8;
    lbcidade_id.Top := 122;
    lbcidade_id.Width := 37;
    lbcidade_id.Height := 13;
    lbcidade_id.Caption := 'Cidade:';
    lbcidade_id.HeightPercent := 100.000000000000000000;
    lbcidade_id.WidthPercent := 100.000000000000000000;
    lbendereco.SetParentComponent(Self);
    lbendereco.Name := 'lbendereco';
    lbendereco.Left := 8;
    lbendereco.Top := 149;
    lbendereco.Width := 49;
    lbendereco.Height := 13;
    lbendereco.Caption := 'Endere'#231'o:';
    lbendereco.HeightPercent := 100.000000000000000000;
    lbendereco.WidthPercent := 100.000000000000000000;
    lbcep.SetParentComponent(Self);
    lbcep.Name := 'lbcep';
    lbcep.Left := 8;
    lbcep.Top := 177;
    lbcep.Width := 23;
    lbcep.Height := 13;
    lbcep.Caption := 'Cep:';
    lbcep.HeightPercent := 100.000000000000000000;
    lbcep.WidthPercent := 100.000000000000000000;
    lbtelefone.SetParentComponent(Self);
    lbtelefone.Name := 'lbtelefone';
    lbtelefone.Left := 224;
    lbtelefone.Top := 12;
    lbtelefone.Width := 46;
    lbtelefone.Height := 13;
    lbtelefone.Caption := 'Telefone:';
    lbtelefone.HeightPercent := 100.000000000000000000;
    lbtelefone.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 224;
    lbcodigo_interno.Top := 39;
    lbcodigo_interno.Width := 47;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 224;
    lbexcluido.Top := 66;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 224;
    lbinclusao.Top := 93;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 224;
    lbalteracao.Top := 120;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 224;
    lbexclusao.Top := 147;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 224;
    btCancel.Top := 171;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 77;
    edid.Top := 9;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 77;
    ednome.Top := 38;
    ednome.Width := 120;
    ednome.Height := 21;
    ednome.Enabled := False;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edemail.SetParentComponent(Self);
    edemail.Name := 'edemail';
    edemail.Left := 77;
    edemail.Top := 65;
    edemail.Width := 120;
    edemail.Height := 21;
    edemail.Enabled := False;
    edemail.HeightPercent := 100.000000000000000000;
    edemail.TabOrder := 10;
    edemail.Text := 'edemail';
    edemail.WidthPercent := 100.000000000000000000;
    edemail.DataField := 'email';
    edemail.DataSource := DataSource;
    edcnpj.SetParentComponent(Self);
    edcnpj.Name := 'edcnpj';
    edcnpj.Left := 77;
    edcnpj.Top := 92;
    edcnpj.Width := 120;
    edcnpj.Height := 21;
    edcnpj.Enabled := False;
    edcnpj.HeightPercent := 100.000000000000000000;
    edcnpj.TabOrder := 11;
    edcnpj.Text := 'edcnpj';
    edcnpj.WidthPercent := 100.000000000000000000;
    edcnpj.DataField := 'cnpj';
    edcnpj.DataSource := DataSource;
    edcidade_id.SetParentComponent(Self);
    edcidade_id.Name := 'edcidade_id';
    edcidade_id.Left := 77;
    edcidade_id.Top := 119;
    edcidade_id.Width := 120;
    edcidade_id.Height := 21;
    edcidade_id.Enabled := False;
    edcidade_id.HeightPercent := 100.000000000000000000;
    edcidade_id.TabOrder := 12;
    edcidade_id.Text := 'edcidade_id';
    edcidade_id.WidthPercent := 100.000000000000000000;
    edcidade_id.DataField := 'cidade.Nome';
    edcidade_id.DataSource := DataSource;
    edendereco.SetParentComponent(Self);
    edendereco.Name := 'edendereco';
    edendereco.Left := 77;
    edendereco.Top := 146;
    edendereco.Width := 120;
    edendereco.Height := 21;
    edendereco.Enabled := False;
    edendereco.HeightPercent := 100.000000000000000000;
    edendereco.TabOrder := 13;
    edendereco.Text := 'edendereco';
    edendereco.WidthPercent := 100.000000000000000000;
    edendereco.DataField := 'endereco';
    edendereco.DataSource := DataSource;
    edcep.SetParentComponent(Self);
    edcep.Name := 'edcep';
    edcep.Left := 77;
    edcep.Top := 174;
    edcep.Width := 120;
    edcep.Height := 21;
    edcep.Enabled := False;
    edcep.HeightPercent := 100.000000000000000000;
    edcep.TabOrder := 17;
    edcep.Text := 'edcep';
    edcep.WidthPercent := 100.000000000000000000;
    edcep.DataField := 'cep';
    edcep.DataSource := DataSource;
    edtelefone.SetParentComponent(Self);
    edtelefone.Name := 'edtelefone';
    edtelefone.Left := 317;
    edtelefone.Top := 9;
    edtelefone.Width := 120;
    edtelefone.Height := 21;
    edtelefone.Enabled := False;
    edtelefone.HeightPercent := 100.000000000000000000;
    edtelefone.TabOrder := 18;
    edtelefone.Text := 'edtelefone';
    edtelefone.WidthPercent := 100.000000000000000000;
    edtelefone.DataField := 'telefone';
    edtelefone.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 317;
    edcodigo_interno.Top := 36;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 19;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 317;
    edinclusao.Top := 90;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 21;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 317;
    edalteracao.Top := 117;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 22;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 317;
    edexclusao.Top := 144;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 23;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 317;
    cbxexcluido.Top := 65;
    cbxexcluido.Width := 120;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ContadoresDataset;
    DataSource.Left := 256;
    DataSource.Top := 216;
    ContadoresDataset.SetParentComponent(Self);
    ContadoresDataset.Name := 'ContadoresDataset';
    ContadoresDataset.AfterApplyUpdates := ContadoresDatasetAfterApplyUpdates;
    ContadoresDataset.EntitySetName := 'Contadores';
    ContadoresDataset.Connection := DMConnection.ApiConnection;
    ContadoresDataset.Left := 168;
    ContadoresDataset.Top := 216;
    ContadoresDatasetid.SetParentComponent(ContadoresDataset);
    ContadoresDatasetid.Name := 'ContadoresDatasetid';
    ContadoresDatasetid.FieldName := 'id';
    ContadoresDatasetid.Required := True;
    ContadoresDatasetaliado_id.SetParentComponent(ContadoresDataset);
    ContadoresDatasetaliado_id.Name := 'ContadoresDatasetaliado_id';
    ContadoresDatasetaliado_id.FieldName := 'aliado_id';
    ContadoresDatasetaliado_id.Required := True;
    ContadoresDatasetdata_base_id.SetParentComponent(ContadoresDataset);
    ContadoresDatasetdata_base_id.Name := 'ContadoresDatasetdata_base_id';
    ContadoresDatasetdata_base_id.FieldName := 'data_base_id';
    ContadoresDatasetdata_base_id.Required := True;
    ContadoresDatasetnome.SetParentComponent(ContadoresDataset);
    ContadoresDatasetnome.Name := 'ContadoresDatasetnome';
    ContadoresDatasetnome.FieldName := 'nome';
    ContadoresDatasetnome.Required := True;
    ContadoresDatasetnome.Size := 255;
    ContadoresDatasetemail.SetParentComponent(ContadoresDataset);
    ContadoresDatasetemail.Name := 'ContadoresDatasetemail';
    ContadoresDatasetemail.FieldName := 'email';
    SetEvent(ContadoresDatasetemail, Self, 'OnGetText', 'ContadoresDatasetemailGetText');
    ContadoresDatasetemail.Size := 255;
    ContadoresDatasetcnpj.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcnpj.Name := 'ContadoresDatasetcnpj';
    ContadoresDatasetcnpj.FieldName := 'cnpj';
    SetEvent(ContadoresDatasetcnpj, Self, 'OnGetText', 'ContadoresDatasetcnpjGetText');
    ContadoresDatasetcnpj.Size := 255;
    ContadoresDatasetcidade_id.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcidade_id.Name := 'ContadoresDatasetcidade_id';
    ContadoresDatasetcidade_id.FieldName := 'cidade_id';
    ContadoresDatasetendereco.SetParentComponent(ContadoresDataset);
    ContadoresDatasetendereco.Name := 'ContadoresDatasetendereco';
    ContadoresDatasetendereco.FieldName := 'endereco';
    SetEvent(ContadoresDatasetendereco, Self, 'OnGetText', 'ContadoresDatasetenderecoGetText');
    ContadoresDatasetendereco.Size := 255;
    ContadoresDatasetbairro.SetParentComponent(ContadoresDataset);
    ContadoresDatasetbairro.Name := 'ContadoresDatasetbairro';
    ContadoresDatasetbairro.FieldName := 'bairro';
    ContadoresDatasetbairro.Size := 255;
    ContadoresDatasetnumero.SetParentComponent(ContadoresDataset);
    ContadoresDatasetnumero.Name := 'ContadoresDatasetnumero';
    ContadoresDatasetnumero.FieldName := 'numero';
    ContadoresDatasetnumero.Size := 255;
    ContadoresDatasetcomplemento.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcomplemento.Name := 'ContadoresDatasetcomplemento';
    ContadoresDatasetcomplemento.FieldName := 'complemento';
    ContadoresDatasetcomplemento.Size := 255;
    ContadoresDatasetcep.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcep.Name := 'ContadoresDatasetcep';
    ContadoresDatasetcep.FieldName := 'cep';
    ContadoresDatasetcep.Required := True;
    SetEvent(ContadoresDatasetcep, Self, 'OnGetText', 'ContadoresDatasetcepGetText');
    ContadoresDatasetcep.Size := 255;
    ContadoresDatasetcodigo_interno.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcodigo_interno.Name := 'ContadoresDatasetcodigo_interno';
    ContadoresDatasetcodigo_interno.FieldName := 'codigo_interno';
    ContadoresDatasetcodigo_interno.Required := True;
    ContadoresDatasettelefone.SetParentComponent(ContadoresDataset);
    ContadoresDatasettelefone.Name := 'ContadoresDatasettelefone';
    ContadoresDatasettelefone.FieldName := 'telefone';
    SetEvent(ContadoresDatasettelefone, Self, 'OnGetText', 'ContadoresDatasettelefoneGetText');
    ContadoresDatasettelefone.Size := 255;
    ContadoresDatasetexcluido.SetParentComponent(ContadoresDataset);
    ContadoresDatasetexcluido.Name := 'ContadoresDatasetexcluido';
    ContadoresDatasetexcluido.FieldName := 'excluido';
    ContadoresDatasetinclusao.SetParentComponent(ContadoresDataset);
    ContadoresDatasetinclusao.Name := 'ContadoresDatasetinclusao';
    ContadoresDatasetinclusao.FieldName := 'inclusao';
    ContadoresDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ContadoresDatasetalteracao.SetParentComponent(ContadoresDataset);
    ContadoresDatasetalteracao.Name := 'ContadoresDatasetalteracao';
    ContadoresDatasetalteracao.FieldName := 'alteracao';
    ContadoresDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ContadoresDatasetexclusao.SetParentComponent(ContadoresDataset);
    ContadoresDatasetexclusao.Name := 'ContadoresDatasetexclusao';
    ContadoresDatasetexclusao.FieldName := 'exclusao';
    ContadoresDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ContadoresDatasetcidadeNome.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcidadeNome.Name := 'ContadoresDatasetcidadeNome';
    ContadoresDatasetcidadeNome.FieldName := 'cidade.Nome';
    SetEvent(ContadoresDatasetcidadeNome, Self, 'OnGetText', 'ContadoresDatasetcidadeNomeGetText');
    ContadoresDatasetcidadeufSigla.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcidadeufSigla.Name := 'ContadoresDatasetcidadeufSigla';
    ContadoresDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    XDataClientContadoresGet.SetParentComponent(Self);
    XDataClientContadoresGet.Name := 'XDataClientContadoresGet';
    XDataClientContadoresGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientContadoresGet, Self, 'OnLoad', 'XDataClientContadoresGetLoad');
    XDataClientContadoresGet.Left := 64;
    XDataClientContadoresGet.Top := 216;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbemail.AfterLoadDFMValues;
    lbcnpj.AfterLoadDFMValues;
    lbcidade_id.AfterLoadDFMValues;
    lbendereco.AfterLoadDFMValues;
    lbcep.AfterLoadDFMValues;
    lbtelefone.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edemail.AfterLoadDFMValues;
    edcnpj.AfterLoadDFMValues;
    edcidade_id.AfterLoadDFMValues;
    edendereco.AfterLoadDFMValues;
    edcep.AfterLoadDFMValues;
    edtelefone.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ContadoresDataset.AfterLoadDFMValues;
    ContadoresDatasetid.AfterLoadDFMValues;
    ContadoresDatasetaliado_id.AfterLoadDFMValues;
    ContadoresDatasetdata_base_id.AfterLoadDFMValues;
    ContadoresDatasetnome.AfterLoadDFMValues;
    ContadoresDatasetemail.AfterLoadDFMValues;
    ContadoresDatasetcnpj.AfterLoadDFMValues;
    ContadoresDatasetcidade_id.AfterLoadDFMValues;
    ContadoresDatasetendereco.AfterLoadDFMValues;
    ContadoresDatasetbairro.AfterLoadDFMValues;
    ContadoresDatasetnumero.AfterLoadDFMValues;
    ContadoresDatasetcomplemento.AfterLoadDFMValues;
    ContadoresDatasetcep.AfterLoadDFMValues;
    ContadoresDatasetcodigo_interno.AfterLoadDFMValues;
    ContadoresDatasettelefone.AfterLoadDFMValues;
    ContadoresDatasetexcluido.AfterLoadDFMValues;
    ContadoresDatasetinclusao.AfterLoadDFMValues;
    ContadoresDatasetalteracao.AfterLoadDFMValues;
    ContadoresDatasetexclusao.AfterLoadDFMValues;
    ContadoresDatasetcidadeNome.AfterLoadDFMValues;
    ContadoresDatasetcidadeufSigla.AfterLoadDFMValues;
    XDataClientContadoresGet.AfterLoadDFMValues;
  end;
end;

end.
